import { useEffect, useState } from "react";
import supabase from "../lib/supabaseClient";
import { orderAscending } from "../admin/collectionsConfig";

export function useCollection(table) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    supabase.from(table).select("*").order("order", { ascending: orderAscending(table) })
      .then(({ data, error }) => {
        if (!active) return;
        if (error) console.error(error);
        setData(data || []);
        setLoading(false);
      });
    return () => { active = false; };
  }, [table]);
  return { data, loading };
}

export function useProfile() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    supabase.from("profile").select("*").limit(1).maybeSingle()
      .then(({ data, error }) => {
        if (!active) return;
        if (error) console.error(error);
        setData(data || null);
        setLoading(false);
      });
    return () => { active = false; };
  }, []);
  return { data, loading };
}

// Editable categories for a given scope (experience|projects|studies|skills).
export function useCategories(scope) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    supabase
      .from("categories")
      .select("*")
      .eq("scope", scope)
      .order("order", { ascending: true })
      .then(({ data, error }) => {
        if (!active) return;
        if (error) console.error(error);
        setData(data || []);
        setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [scope]);
  return { data, loading };
}

export const useStudies = () => useCollection("studies");
export const useExperience = () => useCollection("experience");
export const useProjects = () => useCollection("projects");
export const useSkills = () => useCollection("skills");
export const useLanguages = () => useCollection("languages");
export const useCertifications = () => useCollection("certifications");

// pick("title", row, "es") -> row.title_es
export function pick(field, row, language) {
  if (!row) return "";
  return row[`${field}_${language}`] ?? "";
}
